
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar';
import DashboardMain from './DashboardMain'; 
import UserMaster from './users/UserMaster'
import Retailer from "./Retailer/Retailer.jsx"
import CustomerMaster from './customer/CustomerMaster.jsx';
import Vendor from './vendor/Vendor.jsx';
import SellSMS from './sellsms/SellSMS.jsx';
import BuySMS from './buysms/BuySMS.jsx';
import Settings from './settings/Settings.jsx';
import MenuManagement from './menu_management/MenuManagement.jsx';

function Dashboard() {
  return (
    <div className="dashboard-root-div d-flex">
    {/* <Sidebar />  */}
    <div className="component-section flex-grow-1">
    <Routes>
    <Route path="/" element={<DashboardMain />} />
    <Route path='CustomerOnboarding' element={<CustomerMaster/>}/>
    <Route path='retailerMaster' element={<Retailer/>}/>
    <Route path='vendorMaster' element={<Vendor/>}/>
    <Route path="userMaster" element={<UserMaster />} />
    <Route path='sellsms' element={<SellSMS/>}/>
    <Route path='buysms' element={<BuySMS/>}/>
    <Route path='menuManagement' element={<MenuManagement/>}/>
    <Route path='settings' element={<Settings/>}/>
  </Routes>
  </div>
  </div>
  );
}

export default Dashboard;
